module.exports = __webpack_public_path__ + "img/12_41.cd94f5d5.png";